import React, { useEffect, useState, useRef }  from 'react';
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Tooltip as Mensaje } from "react-tooltip";
import { cantidadDeportistas, traerRecords, traerRecordsEvento } from '../controllers/configuracionFirebase';
import { coloresFechaCierre, time, timeLocal } from '../controllers/tiempoLimiteInscripcion';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import Mapa from './Mapa'
import { Message } from 'primereact/message';
import Conctatenos from './Conctatenos';
import CountUp from './CountUp';
import GradientText from './GradientText';
import { datosAdmin } from '../controllers/administrador';
import { OverlayPanel } from 'primereact/overlaypanel';

const Torneos = ({
  setIdTorneoParticipando,
  setParticipando,
  torneos,
  setTorneoEspecifico,
  usuario,
  setVisible,
  fechaGoogle,
  setRecordsMundial,
  setRecordsNacional,
  setRecordsEvento}) => {

  const [ cantNadadores, setCantNadadores ] = useState([]);
  const [ dialogMapa, setDialogMapa ] = useState(false);
  const [ mostrarMensaje, setMostrarMensaje ] = useState(false);
  const [ tituloEvento, setTituloEvento ] = useState('');
  const [ detallesMapa, setDetallesMapa ] = useState({distancia: null, tiempo: null});
  const [ direccion, setDireccion ] = useState('');
  const [ info, setInfo ] = useState();

  const servicios = useRef(null);
  const detallesEvento = React.useRef(null);

  function participar(torneo){
    setTorneoEspecifico(torneo);
    setIdTorneoParticipando(torneo.id);
    setParticipando(true);
    setVisible(true);
    traerRecordsEvento(setRecordsEvento);
    traerRecords(setRecordsMundial, "Mundial", torneo.piscina);
    traerRecords(setRecordsNacional, "Nacional", torneo.piscina);
  }

  function irAlMapa(title, address){
    setDialogMapa(true);
    setTituloEvento(title);
    setDireccion(address)
  }

  function arreglarFecha(fecha){
    const auxFecha = new Date(fecha);
    auxFecha.setDate(auxFecha.getDate() + 1);
    const fechaArreglada = auxFecha.toLocaleDateString('es-ES',{ 
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long'})
    return fechaArreglada;
  }

  function arreglarFechaConHoras(fecha){
    const fechaActualizada = new Date(fecha).toLocaleString('es-ES',{ 
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      weekday: 'long'
    });
    return fechaActualizada;
  }

  const content = (
    <div className="d-flex align-items-center">
        <img alt="logo" src={require("../img/img-logo-swimmingt.webp")} width="50" />
        <div className="ms-2 text-danger">Para ver más detalles, por favor active la función de ubicación en su navegador.</div>
    </div>
  );

  const contentTimeCierre = (torneo, indexTorneo) => {
    return <div className="d-flex align-items-center">
        <div className={`ms-2 ${torneo.image === "" && torneo.inscripcionesCerradas && new Date(fechaGoogle) > new Date(torneo.fechaInscripciones) ? "pt-2 pb-3" : ""}`}>
          {!torneo.inscripcionesCerradas ? `Inscripciones ${torneo.fechaInscripciones}` : 'Inscripciones Cerradas'} <br />
          <div id={`contenedor-fecha${indexTorneo}`}>
              <span style={{textShadow: '0 0 1px black'}}>Faltan </span>
              <span id={`dia${indexTorneo}`} style={{textShadow: '0 0 1px black'}}>00</span>
              <span id={`dia-hora${indexTorneo}`} style={{textShadow: '0 0 1px black'}}></span>
            </div>
          </div>
    </div>
  };

  const contentDetallesMapa = (
    <div className="d-flex align-items-center">
        <img alt="logo" src={require("../img/img-logo-swimmingt.webp")} width="50" />
        <div className="ms-2 text-danger">{detallesMapa.distancia && detallesMapa.tiempo ? `Estás a ${detallesMapa.distancia} de distancia, llegando en ${detallesMapa.tiempo}.` : ''}</div>
    </div>
  );

  function calcularServiciosPws(){
    let total = 0;
    torneos.forEach((tor, indexTorneo) => {
      total += (parseInt((cantNadadores[indexTorneo] || 0) * tor.plataforma)) + (parseInt(tor.jornadas.length * tor.digitador)) + ((parseInt(tor.carril * tor.cronos)) * tor.jornadas.length);
    })
    return total;
  }

  useEffect(() => {
    const aux = [];

    async function obtenerCantidadesDeportistas() {
      for (const tor of torneos) {
        const cant = await cantidadDeportistas(tor.id);
        aux.push(cant);
      }
      setCantNadadores(aux);
    }

    obtenerCantidadesDeportistas();
  }, [torneos, setCantNadadores])

  useEffect(()=>{
    torneos.forEach((tor, indexTor)=>{
      time(tor.fechaInscripciones, tor.id, indexTor, fechaGoogle);
      timeLocal(tor.fechaInscripciones, indexTor);
    })
  },[torneos, fechaGoogle])

  return (
    <>
      {((usuario.nombreclub === datosAdmin.nombre || usuario.nombreclub === 'PROWEBSPORTS') && torneos.length !== 0) && (
        <div className="alert alert-info alert-dismissible fade show mb-0 p-0 rounded-0" role="alert">
          <span>
            <b>Servicios PWS {torneos.length} evento{torneos.length > 1 && 's'}:</b> COP ${(calcularServiciosPws()).toLocaleString()}
            <Button className='py-0 px-1 ms-1 rounded-3 text-primary' text icon='pi pi-receipt' label='Detalles' onClick={(e) => servicios.current.toggle(e)}/>
          </span>
          <OverlayPanel ref={servicios}>
            <div style={{ maxHeight: '300px', overflowY: 'auto'}}>
              <p className='m-0' style={{fontSize: '12px'}}>SERVICIOS - PROWEBSPORTS</p>
              <table className='table text-center table-bordered table-hover table-striped mb-1'>
                {torneos.map((tor, indexTorneo) =>{
                  return <tbody key={indexTorneo}>
                    <tr>
                      <td colSpan={3}>{tor.titulo}</td>
                    </tr>
                    <tr>
                      <th>PLATAFORMA</th>
                      <th>DIGITADOR</th>
                      <th>CRONOS</th>
                    </tr>
                    <tr>
                      <td>{parseInt(cantNadadores[indexTorneo] || 0) + ' x $' + parseInt(tor.plataforma).toLocaleString()}</td>
                      <td>{tor.jornadas.length + ' Jorn. x $' + parseInt(tor.digitador).toLocaleString()}</td>
                      <td>{tor.jornadas.length + ' Jorn. x (' + tor.carril + ' Cronos x $' + parseInt(tor.cronos).toLocaleString() + ')'}</td>
                    </tr>
                    <tr>
                      <td>{'$' + (parseInt((cantNadadores[indexTorneo] || 0) * tor.plataforma)).toLocaleString()}</td>
                      <td>{'$' + (parseInt(tor.jornadas.length * tor.digitador)).toLocaleString()}</td>
                      <td>{'$' + (parseInt(tor.jornadas.length * tor.carril * tor.cronos)).toLocaleString()}</td>
                    </tr>
                    <tr className='text-start'>
                      <td colSpan={3}><b>Total:</b> ${((parseInt((cantNadadores[indexTorneo] || 0) * tor.plataforma)) + (parseInt(tor.jornadas.length * tor.digitador)) + (parseInt(tor.jornadas.length * tor.carril * tor.cronos))).toLocaleString()}</td>
                    </tr>
                  </tbody>
                })}
              </table>
              <p className='m-0'><b>Totals:</b> COP ${(calcularServiciosPws()).toLocaleString()}</p>
              <p className='m-0' style={{fontSize: '12px'}}>Solo tú puedes ver esta sección.</p>
            </div>
          </OverlayPanel>  
        </div>
      )}
      <div className='d-flex flex-column' style={{height: '88vh'}}>
        {torneos.length !== 0 ? (
          <div className='w-100 m-auto flex-fill row row-cols-1 row-cols-sm-2 row-cols-md-4 justify-content-center align-items-start'>
            {torneos.map((torneo, indexTorneo) => {
                return (
                  <motion.div
                    className={`position-relative card m-1 pt-2 col shadow card-torneo ${torneo.inscripcionesCerradas ? 'animacion-rojo' : ''}`}
                    style={{ width: "22rem" }}
                    key={indexTorneo}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: `0.${indexTorneo}5` }}
                    id={`card-torneo${indexTorneo}`}
                  >
                    <span className='linea linea-left'></span>
                    <span className='linea linea-right'></span>
                    <span className='linea linea-top'></span>
                    <span className='linea linea-bottom'></span>
                    <ul className="circles-card-torneo">
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                      <li></li>
                    </ul>
                    <div className="d-flex justify-content-between" style={{zIndex: 1}}>
                      <div
                        className="d-flex align-items-start position-relative" id={`cantNadadores${indexTorneo}`}
                      >
                        <motion.p
                          className='mb-0 fs-5 text-muted'
                          style={{fontFamily: "Calistoga" }}
                        >
                          <CountUp
                            from={0}
                            to={parseInt(cantNadadores[indexTorneo] || 0)}
                            separator="."
                            direction="up"
                            duration={1}
                            className=""
                          />
                        </motion.p>
                      </div>
                      <div className="d-flex align-items-center">
                        <div className='text-muted me-1' style={{fontFamily: 'Calistoga'}} id={`contenedor-diaLocal${indexTorneo}`}>
                          <span className='fs-5' id={`diaLocal${indexTorneo}`}>00</span><span className='fs-5'>D : </span>
                          <span className='fs-5' id={`horaLocal${indexTorneo}`}>00</span><span className='fs-5'>H : </span>
                          <span className='fs-5' id={`minutoLocal${indexTorneo}`}>00</span><span className='fs-5'>M : </span>
                          <span className='fs-5' id={`segundoLocal${indexTorneo}`}>00</span><span className='fs-5'>S</span> 
                        </div>
                        <div id={`informacion${indexTorneo}`}>
                          <i className='pi pi-info-circle text-primary fs-5' style={{cursor: 'pointer'}} onClick={(e) => {setInfo(torneo); detallesEvento.current.toggle(e);}}></i>
                        </div>
                      </div>
                    </div>
                    <Message
                      style={{
                          border: 'solid #696cff',
                          borderWidth: '0 0 0 6px',
                          color: '#696cff',
                          position: 'relative'
                      }}
                      id={`messageFechaCierre${indexTorneo}`}
                      className={`justify-content-center p-1`}
                      severity={coloresFechaCierre(torneo.fechaInscripciones)}
                      content={contentTimeCierre(torneo, indexTorneo)}
                    />
                    <div className="marqueePws">
                      <div className="marquee__innerPws">
                        <span>
                          <GradientText
                            colors={["#ff0000", "#006fff", "#ff0000", "#006fff", "#ff0000"]}
                            animationSpeed={8}
                            showBorder={false}
                            className="custom-class"
                            sizeText="20px"
                            color=""
                          >
                            {torneo.titulo}
                          </GradientText>
                        </span>
                        <span>
                          <GradientText
                            colors={["#ff0000", "#006fff", "#ff0000", "#006fff", "#ff0000"]}
                            animationSpeed={8}
                            showBorder={false}
                            className="custom-class"
                            sizeText="20px"
                            color=""
                          >
                            {torneo.titulo}
                          </GradientText>
                        </span>
                        <span>
                          <GradientText
                            colors={["#ff0000", "#006fff", "#ff0000", "#006fff", "#ff0000"]}
                            animationSpeed={8}
                            showBorder={false}
                            className="custom-class"
                            sizeText="20px"
                            color=""
                          >
                            {torneo.titulo}
                          </GradientText>
                        </span>
                      </div>
                    </div>
                    <Mensaje
                      anchorId={`cantNadadores${indexTorneo}`}
                      place="bottom"
                      content={`Inscritos`}
                      className="bg-primary shadow"
                      style={{ zIndex: 1}}
                    />
                    <Mensaje
                      anchorId={`informacion${indexTorneo}`}
                      place="bottom"
                      content={`Información del evento`}
                      className="bg-primary shadow"
                      style={{ zIndex: 1}}
                    />
                    {torneo.image !== "" ? (
                    <img
                      src={torneo.image}
                      className="card-img-top w-100 position-relative mb-1 rounded"
                      alt="imagen del torneo"
                      style={{ filter: "drop-shadow(-1px 1px 2px black)"}}
                    />
                    ) : (
                      <>
                        <img
                          src={require("../img/img_logo.png")}
                          className="card-img-top m-auto position-relative"
                          alt="imagen del torneo"
                          style={{ width: "200px", filter: "drop-shadow(-1px 1px 2px black)", zIndex: 1000}}
                        />
                        <div className='position-absolute' style={{top: '125px', left: "10px", fontFamily: "Anton SC", letterSpacing: '1px', color: "rgba(3, 3, 3, 0.3)"}}>
                          <p className='p-1 pt-0' style={{fontSize: "25px"}}>{torneo.ciudad.toUpperCase()}</p>
                        </div>
                        <p
                          className='mt-1 m-0 position-absolute'
                          style={{ fontSize: "45px", fontFamily: "Anton SC", letterSpacing: '1px', top: "240px", left: "10px", color: "rgba(3, 3, 3, 0.3)"}}
                        >
                          <CountUp
                            from={0}
                            to={parseInt(cantNadadores[indexTorneo] || 0)}
                            separator="."
                            direction="up"
                            duration={1}
                            className=""
                          />
                        </p>
                        {torneo.cronometros === 'si' && (
                          <>
                            <div className='position-absolute' style={{top: '200px', right: "-42px", fontFamily: "Anton SC", letterSpacing: '1px', color: "rgba(3, 3, 3, 0.3)", rotate: "-90deg"}}>
                              <p className='p-1 pt-0' style={{fontSize: "30px"}}>SISTEMA PWS</p>
                            </div>
                            <div className='position-absolute' style={{top: '185px', right: "-85px", fontFamily: "Anton SC", letterSpacing: '1px', color: "rgba(3, 3, 3, 0.3)", rotate: "-90deg"}}>
                              <p className='p-1 pt-0' style={{fontSize: "25px"}}>SEMI-AUTOMÁTICO</p>
                            </div>
                          </>
                        )}
                      </>
                    )}
                    <div className="card-body p-0 text-center position-relative">
                      {torneo.convocatoria !== '' ? (
                        <>
                          <Link to={torneo.convocatoria} target='_blank'>
                            <i className='pi pi-file-pdf text-danger btn btn-light mb-2 me-2 fs-4' id={`conv${indexTorneo}`}></i>
                          </Link>
                        </>
                      ):(<></>)}
                      <Link to="/inscripciones" onClick={() => participar(torneo)}>
                        <Button type='button' icon='pi pi-users' className='btn btn-success mb-2' label="¡Quiero Participar!" style={{borderRadius: '10px'}}>
                        </Button>
                      </Link>
                      <i type='button' id={`ubi${indexTorneo}`} className='pi pi-map-marker btn btn-light mb-2 ms-2 p-overlay-badge fs-4 position-relative' style={{borderRadius: '10px', color: 'rgb(184,135,0)'}} onClick={() => irAlMapa(torneo.titulo, torneo.direccion)}>
                      </i>
                      <Mensaje
                        anchorId={`ubi${indexTorneo}`}
                        place="bottom"
                        content={`Ubicación`}
                        className="bg-primary shadow"
                        style={{ zIndex: 1}}
                      />
                      <Mensaje
                        anchorId={`conv${indexTorneo}`}
                        place="bottom"
                        content={`Convocatoria`}
                        className="bg-primary shadow"
                        style={{ zIndex: 1}}
                      />
                    </div>
                  </motion.div>
                );
              })
            }
          </div>
        ):(
          <motion.div className='mt-2 pb-2 m-auto bg-light shadow' style={{borderRadius: '10px', maxWidth: '850px'}}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1}}
          >
            <img className='w-50' src={require('../img/img-logo-swimmingt.webp')} alt="Logo prowebsports" />
            <h1>¡BIENVENIDO!</h1>
            <p>No tenemos torneos registrados aún.</p>
          </motion.div>
        )}
        <OverlayPanel ref={detallesEvento}>
          {info && <h6 className='text-center' style={{width: '250px'}}>{info.titulo}</h6>} 
          {info && (<div className='d-flex justify-content-center'>
            <div className={`w-100`} style={{maxWidth: '250px'}}>
              <p className='m-0' style={{lineHeight: 1.1, textAlign: 'justify', fontSize: '13px'}}>
                El evento se llevará a cabo en <b>{info.direccion}</b>, en una piscina de <b>{info.piscina} metros</b> con <b>{info.carril} carriles.</b><br />
                La jornada se realizará el día <b>{arreglarFecha(info.fechaTorneo)}</b>, y finalizará el día <b>{arreglarFecha(info.fechaTorneoF)}.</b><br />
                La participación tendrá un costo de <b>{parseInt(info.valorClub).toLocaleString()}</b> por equipo y <b>{parseInt(info.valorDeportista).toLocaleString()}</b> por deportista. <br />
              </p>
            </div>
          </div>)}
          {info && <p className='m-0' style={{width: '250px', lineHeight: 1.1, textAlign: 'justify', fontSize: '13px'}}>Las inscripciones estarán disponibles en la plataforma hasta el <b>{arreglarFechaConHoras(info.fechaInscripciones)}</b></p>}
        </OverlayPanel>
        <Conctatenos/>
      </div>
      <Dialog visible={dialogMapa} style={{ width: '600px', height: '600px' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header={`${tituloEvento}`} modal className="p-fluid" onHide={() => setDialogMapa(false)}>
        {mostrarMensaje ? (
        <Message
          style={{
              border: 'solid #696cff',
              borderWidth: '0 0 0 6px',
              color: '#696cff'
          }}
          className="border-danger justify-content-center mb-1"
          severity="error"
          content={content}
        />):(
          <Message
          style={{
              border: 'solid #696cff',
              borderWidth: '0 0 0 6px',
              color: '#696cff'
          }}
          className="border-success justify-content-center mb-1"
          severity="success"
          content={contentDetallesMapa}
          />
        )}
        {<Mapa
        direccion={direccion} 
        setMostrarMensaje={setMostrarMensaje} 
        tituloEvento={tituloEvento}
        setDetallesMapa={setDetallesMapa}
        usuario={usuario}/>}
      </Dialog>
    </>
  )
}

export default Torneos;